import moment from 'moment';
export default {
  computed: {
    loggedInData() {
      return appRoot.loggedIn || {};
    },
  },
  methods: {
    formatDate(date, format) {
      if ((date || "").indexOf("2099-12-31")==0)
        return "Does not expire";
      return moment(date, "YYYY-MM-DD HH:mm:ss").format(format);
    },
    formatPriceP(price) {
        return "$"+(price*1 || 0).toFixed(2);
    },
    formatPriceI(item) {
      
    },
    formatPrice(item, prop) {
      console.log(item, prop, [prop]);
      if (!(item[prop]*1))
        return "free";
      return "$ "+(item[prop]*1 || 0).toFixed(2);
    },
    formatPriceRaw(item, prop) {
      return item[prop]*1 || 0;
    },
    formatText(text) {
      text=(text || "")+"";
      text=text.replace(/\</g, "&lt;");
      text=text.replace(/\>/g, "&gt;");
      text=text.replace(/\n/g, "<br />");
      return text;
    },
    formatTitle(title) {
      title=this.formatText(title);
      title=title.replace(/\:/g, "<br />");
      return title;
    },
  },
}
